import axios from "axios";
import { authHeader } from "./headerConfig";

const API_ENDPOINT = process.env.REACT_APP_ENDPOINT + "/api/x-admin/users";

const getMyInfo = async () => {
  const response = await axios.get(
    process.env.REACT_APP_ENDPOINT + "/api/x-admin/me",
    {
      withCredentials: true,
      headers: {
        ...authHeader(),
        Accept: "application/json",
      },
    }
  );
  console.log(response.data);
  return response;
};
const getMyUser = async (username) => {
  const response = await axios.get(`${API_ENDPOINT}?username=${username}`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
  console.log(username);
  console.log(response);
  return response;
};

const getAllUsers = async (page = 1) => {
  const response = await axios.get(`${API_ENDPOINT}?page=${page}`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
  return response;
};
const getAllUsersWithSearch = async (page = 1, searchParam, searchQuery) => {
  const response = await axios.get(
    `${API_ENDPOINT}?page=${page}&${searchParam}=${searchQuery}`,
    {
      withCredentials: true,
      headers: {
        ...authHeader(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
  return response;
};
const getUser = async (id) => {
  const response = await axios.get(`${API_ENDPOINT}/${id}`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
const deleteUser = async (id) => {
  return await axios.delete(`${API_ENDPOINT}/${id}`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};
const addUser = async (data) => {
  return await axios.post(`${API_ENDPOINT}`, data, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};
const getUserTransaction = async (id, page = 1) => {
  console.log(id);
  return await axios.get(`${API_ENDPOINT}/${id}/balance/history?page=${page}`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};
const addBalance = async (data, id) => {
  return await axios.put(`${API_ENDPOINT}/${id}/balance/add`, data, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};
const discountBalance = async (data, id) => {
  return await axios.put(`${API_ENDPOINT}/${id}/balance/discount`, data, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};
const updateUser = async (data, id) => {
  return await axios.put(`${API_ENDPOINT}/${id}`, data, {
    headers: {
      ...authHeader(),
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};
const getTotalUserBalance = async () => {
  const response = await axios.get(`${API_ENDPOINT}/aggregates`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
const getUserOrders = async (id, page) => {
  return await axios.get(`${API_ENDPOINT}/${id}/orders?page=${page}`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

const userServices = {
  getUserOrders,
  getAllUsers,
  deleteUser,
  addUser,
  addBalance,
  discountBalance,
  getUser,
  updateUser,
  getTotalUserBalance,
  getMyInfo,
  getMyUser,
  getAllUsersWithSearch,
  getUserTransaction,
};

export default userServices;
